export const QUESTIONS = [
    {
        name: 'deliveriesNumber',
        label: 'MEASURE_QUESTIONS.DELIVERIES_NUMBER',
        help: 'MEASURE_QUESTIONS.DELIVERIES_NUMBER_HELP',
        placeholder: 'MEASURE_QUESTIONS.DELIVERIES_NUMBER_PLACEHOLDER',
        type: 0,
        inputType: 'select',
        options: [
            { value: '1_5', label: 'MEASURE_QUESTIONS.DELIVERIES_NUMBER_1_5_LABEL' },
            { value: '5_10', label: 'MEASURE_QUESTIONS.DELIVERIES_NUMBER_5_10_LABEL' },
            { value: 'more_10', label: 'MEASURE_QUESTIONS.DELIVERIES_NUMBER_MORE_LABEL' },
        ],
    },
    {
        name: 'makeSendAndCollect',
        label: 'MEASURE_QUESTIONS.CASH_COLLECT',
        help: 'MEASURE_QUESTIONS.CASH_COLLECT_HELP',
        placeholder: 'MEASURE_QUESTIONS.SELECT_OPTION',
        type: 0,
        inputType: 'select',
        options: [
            { value: 'yes', label: 'MEASURE_QUESTIONS.YES' },
            { value: 'no', label: 'MEASURE_QUESTIONS.NO' },
            { value: 'do_not_know', label: 'MEASURE_QUESTIONS.DO_NOT_KNOW' },
        ],
    },
    {
        name: 'coverageDistance',
        label: 'MEASURE_QUESTIONS.MAXIMUM_DELIVERY_DISTANCE',
        help: 'MEASURE_QUESTIONS.MAXIMUM_DELIVERY_DISTANCE_HELP',
        placeholder: 'MEASURE_QUESTIONS.MAXIMUM_DELIVERY_DISTANCE_PLACEHOLDER',
        type: 0,
        inputType: 'select',
        options: [
            { value: '0_5', label: 'MEASURE_QUESTIONS.0_5_KM' },
            { value: '5_10', label: 'MEASURE_QUESTIONS.5_10_KM' },
            { value: 'more_10', label: 'MEASURE_QUESTIONS.MORE_10_KM' },
        ],
    },
    {
        name: 'baseFare',
        label: 'MEASURE_QUESTIONS.AVERAGE_FARE',
        help: 'MEASURE_QUESTIONS.AVERAGE_FARE_HELP',
        placeholder: 'MEASURE_QUESTIONS.AVERAGE_FARE_PLACEHOLDER',
        type: 1,
        inputType: 'number',
        value: 0,
    },
];
